/* eslint-disable @typescript-eslint/naming-convention */
import { getProductCategories, getWimsCategories } from 'features/Product/services/product'
import { getLocations } from 'features/Location/services/location'
import {
  GetAreaListRequestType,
  GetAreaListResponseType,
  getAreaList,
  getAreaDetail,
  CreateUpdateAreaRequestType,
  postArea,
  putArea,
} from 'features/Rack/services/area'
import { getRackStorage } from 'features/Rack/services/rackList'
import { callErrorMsg } from 'helpers/errorMsg'
import { AppDispatchType, RootStateType } from 'store'
import { toastSuccess } from 'utils/toast'
import {
  LocationListType,
  setIsLoading,
  setAreaList,
  setLocationList,
  setModalArea,
  resetModalState,
  setAreaDetail,
} from './slice'

export const SLICE_NAME = 'MASTER_AREA/list'

export type AreaParamsType = {
  pageSize: number
  pageIndex: number
  locationId: number
  storageId: number
  name: string
}

const getQueryParamsArea = (params?: Partial<AreaParamsType>) => {
  let paramData: GetAreaListRequestType = {
    'pagination.page_index': params?.pageIndex || 1,
    'pagination.page_size': params?.pageSize || 20,
  }
  if (params?.name) {
    paramData = {
      ...paramData,
      'filter.search_name': params.name,
    }
  }
  if (params?.locationId) {
    paramData = {
      ...paramData,
      'filter.location_id': params.locationId,
    }
  }
  if (params?.storageId) {
    paramData = {
      ...paramData,
      'filter.storage_environment_id': params.storageId,
    }
  }
  return paramData
}

export const actGetAreaList =
  (
    params?: Partial<AreaParamsType>,
    callbackFunction?: (areaDataList: GetAreaListResponseType) => void,
  ) =>
  async (dispatch: AppDispatchType) => {
    try {
      const paramData = getQueryParamsArea(params)
      const { data } = await getAreaList(paramData)

      if (callbackFunction) {
        callbackFunction(data.data)
        return
      }
      dispatch(setAreaList(data))
    } catch (error) {
      callErrorMsg(error)
    }
  }

export const actGetLocations =
  (name?: string, callbackFunction?: (locationDataList: LocationListType) => void) =>
  async (dispatch: AppDispatchType) => {
    try {
      const { data } = await getLocations({
        name: name || '',
        pageSize: 20,
      })
      if (callbackFunction) {
        callbackFunction(data.content)
        return
      }
      dispatch(setLocationList(data.content))
    } catch (err) {
      callErrorMsg(err)
    }
  }

export const actGetWimsCategoryApi = (name?: string) => async (dispatch: AppDispatchType) => {
  try {
    dispatch(
      setModalArea({
        isLoadingWimsCategory: true,
      }),
    )
    const { data } = await getWimsCategories({ name })
    const newList = data.data.map((item) => ({
      id: item.id,
      name: item.name,
    }))

    dispatch(
      setModalArea({
        wimsCategoryList: newList,
      }),
    )
  } catch (err) {
    callErrorMsg(err)
  } finally {
    dispatch(
      setModalArea({
        isLoadingWimsCategory: false,
      }),
    )
  }
}

export const actGetCategory = (name?: string) => async (dispatch: AppDispatchType) => {
  try {
    const { data } = await getProductCategories({ is_catalogue: false, name: name || '' })
    dispatch(
      setModalArea({
        categoryList: data.data.categories,
      }),
    )
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actGetRackStorage = () => async (dispatch: AppDispatchType) => {
  try {
    const { data } = await getRackStorage({ type: 'Environment' })
    dispatch(
      setModalArea({
        rackStorageList: data.data.content.filter(
          (item) => !item.rackStorageName.toLowerCase().includes('[invalid]'),
        ),
      }),
    )
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actGetAreaDetail = (id: number) => async (dispatch: AppDispatchType) => {
  try {
    dispatch(setIsLoading(true))
    const { data } = await getAreaDetail(id)
    dispatch(setAreaDetail(data.data))
    dispatch(
      setModalArea({
        isOpen: true,
        selectedId: id,
        type: 'detail',
      }),
    )
    dispatch(setIsLoading(false))
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actPostPutArea =
  (payload: CreateUpdateAreaRequestType) =>
  async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { modalArea, filter } = getState().areaList
    const { selectedId } = modalArea
    dispatch(setModalArea({ isSubmittingData: true }))
    try {
      const { data } = await (modalArea.type === 'add'
        ? postArea(payload)
        : putArea(selectedId, payload))
      toastSuccess(data.message)
      dispatch(
        actGetAreaList({
          pageIndex: filter.pageIndex,
          pageSize: filter.pageSize,
          locationId: filter.selectedLocation.location_id,
        }),
      )
    } catch (err) {
      callErrorMsg(err)
    } finally {
      dispatch(resetModalState())
    }
  }
